<script setup lang="ts">
import { HealthMode } from '@/types';
import { useAppStore } from '@/store/app';
import { currencies } from '@/constants';
import { computed } from 'vue';
import useExchangeRates from '@/helpers/currency/useExchangeRates';

const store = useAppStore();
const exchangeRates = useExchangeRates();

const currencyOptions = computed(() => {
  const availableCurrencies = Object.keys(exchangeRates.data.value ?? {});
  const data = currencies.filter((currency) =>
    availableCurrencies.includes(currency.name),
  );
  return data
    .filter((currency) => currency.type == 'fiat')
    .map((currency) => ({
      title: currency.name,
      value: currency.name,
    }));
});
</script>

<template>
  <v-card class="settings-dropdown mt-2">
    <v-list density="compact">
      <v-list-item title="Currency">
        <template #append>
          <v-select
            v-model="store.currency"
            density="compact"
            variant="solo-filled"
            flat
            hide-details
            :transition="false"
            :items="currencyOptions"
            class="ms-4"
          />
        </template>
      </v-list-item>
      <v-list-item title="Small values">
        <template #append>
          <v-select
            v-model="store.minDisplayedValue"
            density="compact"
            variant="solo-filled"
            flat
            hide-details
            :transition="false"
            :items="[
              { title: 'Show All', value: 0 },
              { title: 'Hide under $0.01', value: 0.01 },
              { title: 'Hide under $1', value: 1 },
              { title: 'Hide under $5', value: 5 },
              { title: 'Hide under $10', value: 10 },
            ]"
            class="ms-4"
          />
        </template>
      </v-list-item>
      <v-list-item title="Health mode">
        <template #append>
          <v-select
            v-model="store.healthMode"
            density="compact"
            variant="solo-filled"
            flat
            hide-details
            item-value="value"
            item-title="title"
            :transition="false"
            :items="[
              {
                value: HealthMode.factor,
                title: 'Factor',
              },
              {
                value: HealthMode.ratio,
                title: 'Ratio',
              },
            ]"
            class="ms-4"
          ></v-select>
        </template>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<style scoped></style>
